import { render, staticRenderFns } from "./JVPCList.vue?vue&type=template&id=0fe16743&"
import script from "./JVPCList.vue?vue&type=script&lang=js&"
export * from "./JVPCList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports